import { render, staticRenderFns } from "./rew.vue?vue&type=template&id=130f2946&scoped=true&"
import script from "./rew.vue?vue&type=script&lang=js&"
export * from "./rew.vue?vue&type=script&lang=js&"
import style0 from "./rew.vue?vue&type=style&index=0&id=130f2946&prod&scoped=true&lang=less&"
import style1 from "./rew.vue?vue&type=style&index=1&id=130f2946&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130f2946",
  null
  
)

export default component.exports